import { Framework } from '@/framework/instance';
import { IEditMessage } from '../../types';
import { OperateType } from '../../types/operate';
import { parseWsKey } from '../../utils';
import { Collaborators } from '../collaborators';
import { Room } from '../room';

/**
 * 用户就绪操作
 */
export class UserSave extends Framework {
    constructor(
        identity: string,
        private room: Room,
        private collaborators: Collaborators,
    ) {
        super(identity);
        this.room.onMessage(OperateType.UserSave, this.onReceiveUserSave.bind(this));
        this.room.onMessage(OperateType.SyncUpdateAt, this.onReceiveSyncUpdateAt.bind(this));
    }

    /** 设置文档更新时间 */
    setUpdateAt(updateAt: number) {
        this.room.getConfig()?.setDocumentUpdateAt(updateAt);
        this.room.sendToAll(OperateType.SyncUpdateAt, [updateAt]);
    }

    /** 收到同步文档更新时间事件回调 */
    private onReceiveSyncUpdateAt({ data }: IEditMessage<number[]>) {
        let [updateAt] = data;
        const currentUpdateAt = this.room.getConfig()?.getDocumentUpdateAt();
        if (currentUpdateAt && currentUpdateAt !== updateAt) {
            updateAt = Math.max(currentUpdateAt, updateAt);
        }
        this.room.getConfig()?.setDocumentUpdateAt(updateAt);
    }

    /** 是否正在保存 */
    isSaving() {
        const res = this.collaborators.getMembers().filter((item) => item.getInfo().isSaving);
        // console.log('ot isSaving', res.length > 0);
        return res.length > 0;
    }

    /** 设置用户保存状态 */
    setSaving(isSaving: boolean) {
        const member = this.collaborators.getMember();
        if (member && member.getInfo().isSaving !== isSaving) {
            // console.log('ot setSaving', isSaving);
            member.setSaving(isSaving);
            this.room.sendToAll(OperateType.UserSave, [isSaving]);
        }
    }

    /** 收到用户保存状态事件回调 */
    private onReceiveUserSave({ fromWsMemberKey, data }: IEditMessage<boolean[]>) {
        const [isSaving] = data;
        const { wsKey } = parseWsKey(fromWsMemberKey);
        this.collaborators.getMember(wsKey)?.setSaving(isSaving);
    }
}
